// storageUtils.js

const EXPIRATION_TIME = 86400 * 1000; // 24 hours in milliseconds
const STORAGE_KEY = "userRoleData";

export const setUserRoleInStorage = (role) => {
  const userData = {
    role,
    expiry: Date.now() + EXPIRATION_TIME, // Set expiration timestamp
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
};

export const getUserRoleFromStorage = () => {
  const storedUser = JSON.parse(localStorage.getItem(STORAGE_KEY));

  if (storedUser && storedUser.expiry > Date.now()) {
    return storedUser.role; // Valid role
  }

  localStorage.removeItem(STORAGE_KEY); // Expired, remove it
  return null;
};
